/* eslint-disable no-alert */
import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Table } from 'semantic-ui-react'

import DriverPendingTimer from '../../../../components/orders/DriverPendingTimer'

import FindDriver from '../../components/OrderListItem/ActionButtons/FindDriver'
import AssignedDriver from '../../components/OrderListItem/ActionButtons/AssignedDriver'

class DriverCell extends PureComponent {
  state = {
    finding: false,
    loading: false,
  }

  setLoading = (field, value) => {
    this.setState({ [field]: value })
  }

  renderFindDriverButton = () => {
    const { order, showManualAssign, readOnly, queueOrders } = this.props

    return (
      <FindDriver
        key="find"
        order={order}
        setLoading={this.setLoading}
        showManualAssign={showManualAssign}
        queueOrders={queueOrders}
        readOnly={readOnly}
        {...this.state}
      />
    )
  }

  renderPendingDriver = () => {
    const { drivers, order } = this.props
    const driverUid = order.driver_pending_order
    const driver = drivers[driverUid]

    if (driver) {
      const driverName = `${driver.family_name} ${driver.first_name}`

      return (
        <DriverPendingTimer
          key="pending"
          driverName={driverName}
          driverTel={driverUid}
          expiredAt={order.driver_pending_expired_at}
          hasDivider={order.switching_driver}
        />
      )
    }

    return null
  }

  renderAssignedDriver = () => {
    const { drivers, order } = this.props
    const driverUid = order.deliverer
    const driver = drivers[driverUid]

    if (!driver) return null

    return <AssignedDriver order={order} driver={driver} key="assign" />
  }

  render() {
    const actions = []
    const { order, rowSpan } = this.props

    if (order.driver_pending_order && order.driver_pending_expired_at) {
      actions.push(this.renderPendingDriver())
    } else if (
      !order.deliverer &&
      ['confirmed', 'drivers_not_available'].includes(order.status) &&
      !order.driver_pending_order
    ) {
      actions.push(this.renderFindDriverButton())
    }

    return (
      <Table.Cell textAlign="center" rowSpan={rowSpan}>
        {actions}
      </Table.Cell>
    )
  }
}

const mapState = ({ drivers }) => ({
  drivers: drivers.drivers,
})

export default connect(mapState)(DriverCell)



// WEBPACK FOOTER //
// ./src/containers/orders/guide/components/DriverCell.js